export default {
  title: 'Erreur technique',
  message: 'Une erreur technique est survenue. Nous sommes désolés des inconvénients que cela peut vous causer.',
  technicalErrorButton: 'Aller à l’accueil',
};
